import Vue from 'vue'
import Router from 'vue-router'
import Meals from '@/pages/meals'
import Login from '@/pages/login'
import User from '@/pages/user'
import Order from '@/components/user/order'
import Comment from '@/components/user/comment'
import Money from '@/components/user/money'
import RecommendedShop from '@/components/user/recommended_shop'
import Setting from '@/components/user/setting'
import Feedback from '@/components/user/feedback'
import Detail from '@/components/user/detail'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/p/meals'
    },
    {
      path: '/p',
      redirect: '/p/meals'
    },
    {
      path: '/p/login',
      name: 'login',
      component: Login
    },
    {
      path: '/p/meals',
      name: 'meals',
      component: Meals
    },
    {
      path: '/p/user',
      name: 'user',
      component: User,
      children: [
        {
          path: 'order',
          component: Order
        },
        {
          path: 'money',
          component: Money
        },
        {
          path: 'comment',
          component: Comment
        },
        {
          path: 'recommended_shop',
          component: RecommendedShop
        },
        {
          path: 'setting',
          component: Setting
        },
        {
          path: 'money/feedback',
          component: Feedback
        },
        {
          path: 'money/detail',
          component: Detail
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js